import Components from "slotworks/components/components";
import PromptContent from "slotworks/components/prompt/prompt-content";
import Contract from "slotworks/utils/contracts/contract";

export function YesNoPromptCommand(prompt: PromptContent, yesUpHandler: () => void, noUpHandler: () => void) {
    return new Contract<boolean>((resolve) => {

        prompt.addContinueButton();
        prompt.addButton("no", () => {
            prompt.hide().execute();
            noUpHandler();
            resolve(false);
        });

        Components.prompt.showPrompt(prompt).then(() => {
            prompt.hide().execute();
            yesUpHandler();
            resolve(true);
        });
    });
}
